import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styles from "./SierraChat.module.css";
import "./SierraWidget.css";
import { ProgressIndicator } from "@asosteam/asos-web-component-library-progress-indicator";
import noticeError from "src/app/utilities/noticeError";
import {
  deleteChatWidgetParam,
  sierraChatTimeoutAction,
  init,
} from "src/app/utilities/sierraChat";
import { trackEvent } from "../../utilities/optimizely";
import { EXPERIMENTS } from "../../utilities/experiments";
import { cleanupNotificationHandler } from "./utils/onAgentMessageEnd";

export const SierraChat = ({ setLoadError, setShow }) => {
  const [loading, setLoading] = useState(true);

  const toggleChatModal = () => {
    if (window.sierra) {
      window.sierra.openChatModal();
      setLoading(false);
    } else {
      const initError = new Error("Sierra Chat: init error.");
      noticeError(initError);
      setLoadError(initError);
    }
  };

  const onClose = () => {
    deleteChatWidgetParam();
    setShow(false);
  };

  useEffect(() => {
    let timeout;

    const initSierraSDK = async () => {
      if (!window.sierra) {
        try {
          await init(toggleChatModal);
          sierraChatTimeoutAction(timeout, setShow, setLoadError);
        } catch (error) {
          noticeError(error);
          setShow(false);
          setLoadError(error);
        }
      }

      if (!window.asos?.sierra) {
        window.asos.sierra = {};
        window.asos.sierra.onClose = onClose;
      }
    };

    initSierraSDK();
    trackEvent(EXPERIMENTS.SIERRA_CHAT.EVENTS.SIERRA);

    return () => {
      clearTimeout(timeout);
      cleanupNotificationHandler();
    };
  }, []);

  return (
    <>
      {loading && (
        <div className={styles.loader}>
          <ProgressIndicator size="large" progressMessage="loading" />
        </div>
      )}
      <div
        id="sierra-chat-container"
        data-sierra-chat-container
        className={styles.sierraChatContainer}
        data-testid="sierra-chat-container"
      ></div>
    </>
  );
};

SierraChat.propTypes = {
  setLoadError: PropTypes.func,
  setShow: PropTypes.func,
};
